export default {
    modalShowImageVariations: {
        imageAi: 'Image AI',
        regenerateImage: 'Neuen Inhalt generieren',
        description: 'Beschreibung:',
        style: 'Style:',
        saveToLibrary: 'Save to Library',
        continue: 'Weiter',
        cancel: 'Abbrechen',
        select: 'Select',
        copy: 'Kopieren',
    },
};
